// Filename: public/recommendationScores.js

// Code written in public files is shared by your site's
// Backend, page code, and site code environments.

// Use public files to hold utility functions that can
// be called from multiple locations in your site's code.

import wixData from 'wix-data';

export async function recommendationScores(receivedItem) {
    // console.log("item id for career quiz", item.ReportingResults);
    let scores = {
        "lifeSatisfaction2Results": 1000,
        "resultsPersonality": 500,
        "resultsPersonalValues": 500,
        "resultsEmotionalIntelligence": 100
    };
    let existingResults = {}
    console.log("wow received Item", receivedItem)

    let databases = await wixData.query("resultsPersonality")
        .eq("resultId", receivedItem.resultsPersonality)
        .find()
        .then((results) => {
            
            // console.log("wow result resultsPersonality", results.items[0])
            existingResults["resultsPersonality"] = results.items[0]

            wixData.query("lifeSatisfaction2Results")
                .eq("resultId", receivedItem.lifeSatisfaction2Results)
                .find()
                .then((results) => {
                    // console.log("wow result lifeSatisfaction2Results", results.items[0]);
                    existingResults["lifeSatisfaction2Results"] = results.items[0]

                    wixData.query("resultsPersonalValues")
                        .eq("resultId", receivedItem.resultsPersonalValues)
                        .find()
                        .then((results) => {
                            // console.log("wow result resultsPersonalValues", results.items[0])
                            existingResults["resultsPersonalValues"] = results.items[0]
                        }).then(() => {

                            wixData.query("RecomendationScores")
                                .find()
                                .then((results) => {
                                    // console.log("wow result recommendation", results.items)
                                    results.items.forEach((line) => {

                                        var keys = Object.keys(line);
                                        keys.forEach((column) => {
                                            // console.log("wow line[column]", line[column]);
                                            let cell = line[column];
                                            // checks if cell si arrar
                                            if (cell[0]) {
                                                // iterate array of the cell
                                                for (let index = 0; index < cell.length; index++) {
                                                    // console.log("line column", line.title, column, line[column])
                                                    // console.log(existingResults)
                                                    if (typeof existingResults[line.title] !== 'undefined') {
                                                        let existingScore = existingResults[line.title][cell[index].area]
                                                        // console.log("title :", line.title);
                                                        // console.log("existin area :", line[column].area);
                                                        // console.log("existin result :", existingScore);
                                                        if (existingScore >= cell[index].lowScore && existingScore <= cell[index].highScore) {
                                                            // console.log("atributed")
                                                            if (typeof scores[column] !== 'undefined') {
                                                                scores[column] += cell[index].points;
                                                            } else {
                                                                scores[column] = cell[index].points;
                                                            }
                                                        }
                                                    }

                                                }

                                            }

                                        })

                                    })
                                    // console.log("scores: ", scores)
                                    if (receivedItem.recommendationScores) {
                                        receivedItem.recommendationScores = scores;
                                        wixData.update("lastQuizTaken", receivedItem);
                                    }

                                });

                        });

                });

        });

    //scores = {"lifeSatisfaction":28};
    // console.log("databases", databases)
    return scores;

}